import React from "react";
import "./dashboard-section.css";

const DashboardSection = ({
	children,
	className = "",
	columns = "default"
}) => (
	<section
		className={[
			"dashboard-section",
			`dashboard-section--${columns}`,
			className
		].filter(Boolean).join(" ")}
	>
		{children}
	</section>
);

export default DashboardSection;